import React from "react";
import ReactHOC from "../../../../../common/react-hoc";
import SliderView from "./slider.jsx";
import { FlexComponentBootstrap } from "../../../../../common/component-bootstraper";
import Spinner from "./spinner.jsx";

class CarouselImageSpotApp extends React.Component {
  constructor(props) {
    super(props);

    this.imageSpotList = this.props.settings.imageSpotList;

    this.state = {
      initiated: false
    };

    this.updateInitiated = this.updateInitiated.bind(this);
  }

  updateInitiated(isInitated) {
    this.setState({ initiated: isInitated });
  }

  render() {
    return (
      <>
        {!this.state.initiated && <Spinner />}
        <SliderView
          list={this.imageSpotList}
          isInitated={this.state.initiated}
          updateInitiated={this.updateInitiated}
        />
      </>
    );
  }
}

const carouselImageSpot = new FlexComponentBootstrap(
  "image-spot",
  ".as-carousel"
);
carouselImageSpot.reactApp = ReactHOC(CarouselImageSpotApp);
carouselImageSpot.run();
